import React, { useState } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const Card = ({ title, children }) => {
  const [hover, setHover] = useState(false);

  const cardStyle = {
    border: hover ? "1px solid #cbd5e1" : "1px solid #e2e8f0",
    padding: "24px",
    borderRadius: "16px",
    marginBottom: "20px",
    background: "linear-gradient(135deg,#ffffff,#f8fafc)",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden",
    transform: hover ? "translateY(-4px)" : "translateY(0)",
    boxShadow: hover
      ? "0 12px 32px rgba(30,79,138,0.12)"
      : "none",
  };

  const topBorder = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "4px",
    background: "linear-gradient(90deg,#1e4f8a,#2a6bb3,#357abd)",
    transform: hover ? "scaleX(1)" : "scaleX(0)",
    transformOrigin: "left",
    transition: "transform 0.3s ease",
  };

  const titleStyle = {
    color: hover ? "#1e4f8a" : "#1e293b",
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "20px",
    transition: "color 0.3s ease",
  };

  return (
    <div
      style={cardStyle}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div style={topBorder}></div>

      {title && <h5 style={titleStyle}>{title}</h5>}

      {children}
    </div>
  );
};
const styles = {
  container: {
    padding: "10px 0 40px",
  },

  profileHeader: {
    background: "linear-gradient(135deg,#1e4f8a 0%,#2a6bb3 50%,#357abd 100%)",
    color: "white",
    padding: "32px 36px",
    display: "flex",
    gap: "24px",
    alignItems: "center",
    borderRadius: "16px",
    boxShadow: "0 10px 32px rgba(30,79,138,0.2)",
    marginBottom: "32px",
  },

  avatarContainer: {
    display: "flex",
    alignItems: "center",
  },

  avatar: {
    width: "82px",
    height: "82px",
    borderRadius: "50%",
    background: "rgba(255,255,255,0.15)",
    color: "white",
    fontSize: "28px",
    fontWeight: "700",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "3px solid rgba(255,255,255,0.35)",
    overflow: "hidden",
  },

  avatarImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  profileInfo: {
    flex: 1,
  },

  nameSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "8px",
    marginBottom: "16px",
    
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
    }
  },

  name: {
    margin: 0,
    fontSize: "28px",
    fontWeight: "700",
    color: "white",
  },

  verified: {
    background: "linear-gradient(135deg, #10b981, #059669)",
    padding: "5px 12px",
    borderRadius: "18px",
    fontSize: "11px",
    fontWeight: "600",
    color: "#ffffff",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    display: "inline-flex",
    alignItems: "center",
    gap: "2px",
    boxShadow: "0 2px 8px rgba(16, 185, 129, 0.3)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    transition: "all 0.3s ease",
    cursor: "default",
    
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(16, 185, 129, 0.4)",
    }
  },

  specializationText: {
    margin: "0 0 12px 0",
    fontSize: "16px",
    color: "rgba(255,255,255,0.9)",
    fontWeight: "500",
  },

  section: {
    marginTop: "36px",
  },

  sectionTitle: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#1e4f8a",
    letterSpacing: "1.5px",
    marginBottom: "18px",
    textTransform: "uppercase",
  },

  downloadRow: {
    display: "flex",
    gap: "16px",
    flexWrap: "wrap",
  },

  downloadButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "12px 18px",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    background: "#fff",
    cursor: "pointer",
    minWidth: "210px",
  },

  buttonText: {
    flex: 1,
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
  },

  card: {
    border: "1px solid #e2e8f0",
    padding: "24px",
    borderRadius: "16px",
    marginBottom: "20px",
    background: "linear-gradient(135deg,#ffffff,#f8fafc)",
  },

  cardTitle: {
    color: "#1e293b",
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "20px",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(2,1fr)",
    gap: "20px",
  },

  label: {
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    color: "#64748b",
    textTransform: "uppercase",
  },

  value: {
    marginTop: "6px",
    fontSize: "15px",
    fontWeight: "500",
    color: "#1e293b",
  },

  tenure: {
    marginTop: "18px",
    fontSize: "14px",
    color: "#475569",
    fontWeight: "500",
  },
};

const ProfessionalDetailsUser = ({
  professionalData,
  hasVerificationCertificate,
  handleResume,
  handleRegistration,
  handleDownLoadVerification,
  getInitials,
}) => {
  const cvDoc = professionalData?.documents?.find(
    (doc) => doc.docType?.name === "CV"
  );
  
  return (
    <div style={styles.container}>
      {/* HEADER */}
      <div style={styles.profileHeader}>
        <div style={styles.avatarContainer}>
          <div style={styles.avatar}>
            {professionalData?.avatar?.url ? (
              <img
                src={professionalData?.avatar?.url}
                alt=""
                style={styles.avatarImg}
              />
            ) : (
              getInitials(professionalData?.name?.full)
            )}
          </div>
        </div>

        <div style={styles.profileInfo}>
          <div style={styles.nameSection}>
            <h2 style={styles.name}>{professionalData?.name?.full}</h2>
            {professionalData?.status === "ACTIVE" && (
              <span style={styles.verified}>
                <svg 
                  width="12" 
                  height="12" 
                  viewBox="0 0 12 12" 
                  fill="none" 
                  // style={{ marginRight: "2px" }}
                >
                  <path 
                    d="M10 3L4.5 8.5L2 6" 
                    stroke="currentColor" 
                    strokeWidth="1.5" 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                  />
                </svg>
                VERIFIED
              </span>
            )}
          </div>

          <p style={styles.specializationText}>
            {professionalData?.specialization?.name} ·{" "}
            {professionalData?.numExperience?.name}
          </p>
        </div>
      </div>

      {/* DOCUMENTS */}
      <section style={styles.section}>
        <h4 style={styles.sectionTitle}>Documents & Certificates</h4>

        <div style={styles.downloadRow}>
          {cvDoc?.files?.[0]?.url&& 
          <button
            style={styles.downloadButton}
            // onClick={() =>
            //   handleResume(
            //     professionalData?.professionalResume?.find(
            //       (r) => r.resumeStatus === true
            //     )
            //   )
            // }
            onClick={() => {
              const activeResume = professionalData?.professionalResume?.length
                ? professionalData?.professionalResume?.find(
                    (r) => r.resumeStatus === true
                  )
                : null;
            
              const cvDoc = professionalData?.documents?.find(
                (doc) => doc.docType?.name === "CV"
              );
            
              const finalData = activeResume
                ?  activeResume?.AIResumeUrl || activeResume?.manualResumeUrl
                : cvDoc?.files?.[0]?.url;
            
              handleResume(finalData);
            }}
          >
            <span style={styles.buttonText}>Resume</span>
            <VisibilityOutlinedIcon />
          </button>
}
          <button style={styles.downloadButton} onClick={handleRegistration}>
            <span style={styles.buttonText}>Registration Certificate</span>
            <VisibilityOutlinedIcon />
          </button>

          {hasVerificationCertificate && (
            <button
              style={styles.downloadButton}
              onClick={handleDownLoadVerification}
            >
              <span style={styles.buttonText}>Verification Certificate</span>
              <VisibilityOutlinedIcon />
            </button>
          )}
        </div>
      </section>

      {/* PROFESSIONAL INFORMATION */}
      <section style={styles.section}>
        <h4 style={styles.sectionTitle}>PROFESSIONAL INFORMATION</h4>

        {/* <div style={styles.card}> */}
        <Card>
          <div style={styles.grid}>
            <div>
              <label style={styles.label}>PROFESSION</label>
              <p style={styles.value}>
                {professionalData?.professionalType?.name}
              </p>
            </div>

            <div>
              <label style={styles.label}>HIGHEST QUALIFICATION</label>
              <p style={styles.value}>
                {professionalData?.qualification?.name}
              </p>
            </div>

            <div>
              <label style={styles.label}>TOTAL WORK EXPERIENCE</label>
              <p style={styles.value}>
                {professionalData?.numExperience?.name}
              </p>
            </div>

            <div>
              <label style={styles.label}>SPECIALISATION</label>
              <p style={styles.value}>
                {professionalData?.specialization?.name}
              </p>
            </div>

            <div>
              <label style={styles.label}>OTHER SPECIALISATION</label>
              <p style={styles.value}>
                {professionalData?.departments?.map((d) => d.name).join(", ")}
              </p>
            </div>
          </div>
        {/* </div> */}
        </Card>
      </section>

      {/* EDUCATION */}
      {professionalData?.profile?.education?.length ? (
        <section style={styles.section}>
          <h4 style={styles.sectionTitle}>EDUCATION</h4>

          {professionalData?.profile?.education?.map((education, index) => (
            // <div style={styles.card} key={index}>
            //   <h5 style={styles.cardTitle}>{education?.course}</h5>
<Card key={index} title={education?.course}>
              <div style={styles.grid}>
                <div>
                  <label style={styles.label}>COLLEGE / UNIVERSITY</label>
                  <p style={styles.value}>{education?.name}</p>
                </div>

                <div>
                  <label style={styles.label}>YEAR OF PASSING</label>
                  <p style={styles.value}>{education?.year}</p>
                </div>
              </div>
              </Card>
            // </div>
          ))}
        </section>
      ) : null}

      {/* WORK EXPERIENCE */}
      {professionalData?.profile?.jobHistory?.length ? (
        <section style={styles.section}>
          <h4 style={styles.sectionTitle}>WORK EXPERIENCE</h4>

          {professionalData?.profile?.jobHistory?.map((work, index) => {
            const startDate = work?.start
              ? new Date(Number(work.start)).toLocaleDateString("en-US", {
                  month: "short",
                  year: "numeric",
                })
              : "";

            const endDate = work?.end
              ? new Date(Number(work.end)).toLocaleDateString("en-US", {
                  month: "short",
                  year: "numeric",
                })
              : "Present";

            return (
              // <div style={styles.card} key={index}>
              //   <h5 style={styles.cardTitle}>{work?.hospital}</h5>
<Card key={index} title={work?.hospital}>
                <div style={styles.grid}>
                  <div>
                    <label style={styles.label}>SPECIALISATION</label>
                    <p style={styles.value}>{work?.specialisation}</p>
                  </div>

                 {work?.department &&  <div>
                    <label style={styles.label}>DEPARTMENT</label>
                    <p style={styles.value}>{work?.department}</p>
                  </div>}
                </div>

                <div style={styles.tenure}>
                  {startDate} → {endDate}
                </div>
              {/* </div> */}
              </Card>
            );
          })}
        </section>
      ) : null}

      {/* REGISTRATION */}
      {professionalData?.professionalRegistration && (
        <section style={styles.section}>
          <h4 style={styles.sectionTitle}>REGISTRATION CERTIFICATE</h4>

          {/* <div style={styles.card}> */}
          <Card>
            <div style={styles.grid}>
              <div>
                <label style={styles.label}>REGISTRATION NO.</label>
                <p style={styles.value}>
                  {professionalData?.professionalRegistration?.number}
                </p>
              </div>

              <div>
                <label style={styles.label}>REGISTERED NAME</label>
                <p style={styles.value}>
                  {
                    professionalData?.professionalRegistration
                      ?.nameAsPerDocument
                  }
                </p>
              </div>

              <div>
                <label style={styles.label}>CERTIFICATE STATE</label>
                <p style={styles.value}>
                  {
                    professionalData?.professionalRegistration
                      ?.registrationState
                  }
                </p>
              </div>

              <div>
                <label style={styles.label}>ISSUING AUTHORITY</label>
                <p style={styles.value}>
                  {professionalData?.professionalRegistration?.instituteName}
                </p>
              </div>
            </div>
            </Card>
          {/* </div> */}
        </section>
      )}
    </div>
  );
};

export default ProfessionalDetailsUser;